/* Wav Monopoly — preset hero accent.
   Tints the left box-art panel with a soft, light color derived from the
   preset's own artwork (or a `preset.accent_color` metafield override), so each
   preset's hero subtly complements its cover. Sets --wm-prh-ah / --wm-prh-as
   (HSL hue + saturation) on .wm-prh__media; wm-preset-pdp.css builds the pastel
   gradient from them. Fully graceful: on any failure the CSS default holds. */
(function () {
  'use strict';

  function clamp(n, lo, hi) { return n < lo ? lo : (n > hi ? hi : n); }

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    var h = 0, s = 0, l = (max + min) / 2;
    if (d !== 0) {
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s * 100, l * 100];
  }

  function hexToRgb(hex) {
    hex = String(hex).trim().replace(/^#/, '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    if (hex.length !== 6 || /[^0-9a-f]/i.test(hex)) return null;
    return [parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16)];
  }

  /* Pick a representative *vibrant* hue: weight each pixel by saturation and
     mid-lightness so near-white / near-black backgrounds are skipped and the
     hue that gives the artwork its character wins. Hue is a circular mean so
     opposing reds don't average to a muddy grey. */
  function vibrantHsl(data) {
    var sumX = 0, sumY = 0, sumW = 0, sSum = 0;
    for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 200) continue;
      var hsl = rgbToHsl(data[i], data[i + 1], data[i + 2]);
      var midness = 1 - Math.abs(hsl[2] - 52) / 52;
      if (midness < 0) midness = 0;
      var w = (hsl[1] / 100) * midness;
      if (w <= 0) continue;
      var rad = hsl[0] * Math.PI / 180;
      sumX += Math.cos(rad) * w; sumY += Math.sin(rad) * w; sumW += w; sSum += hsl[1] * w;
    }
    if (sumW === 0) return null;
    // If the vibrant hues roughly cancel (no dominant hue — e.g. a balanced
    // complementary cover), don't fabricate an arbitrary one; keep the default.
    if (Math.sqrt(sumX * sumX + sumY * sumY) / sumW < 0.15) return null;
    var h = Math.atan2(sumY, sumX) * 180 / Math.PI;
    if (h < 0) h += 360;
    return [h, sSum / sumW, 55];
  }

  // minSat: saturation floor. Extracted artwork gets a pastel floor (28) so faint
  // covers still tint; explicit metafield overrides pass 0 so a chosen neutral stays neutral.
  function applyHsl(media, hsl, minSat) {
    if (!hsl) return;
    var h = ((Math.round(hsl[0]) % 360) + 360) % 360;
    var s = clamp(Math.round(hsl[1]), minSat == null ? 28 : minSat, 68);
    media.style.setProperty('--wm-prh-ah', h);
    media.style.setProperty('--wm-prh-as', s + '%');
  }

  function fromImage(media, src) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.onload = function () {
      try {
        var n = 40;
        var c = document.createElement('canvas');
        c.width = n; c.height = n;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        if (!ctx) return;
        ctx.drawImage(img, 0, 0, n, n);
        applyHsl(media, vibrantHsl(ctx.getImageData(0, 0, n, n).data));
      } catch (e) { /* tainted canvas / blocked — keep the CSS default */ }
    };
    img.src = src;
  }

  function init() {
    var panels = document.querySelectorAll('.wm-prh__media');
    for (var i = 0; i < panels.length; i++) {
      var media = panels[i];
      var override = media.getAttribute('data-accent-color');
      if (override) {
        var rgb = hexToRgb(override);
        if (rgb) { applyHsl(media, rgbToHsl(rgb[0], rgb[1], rgb[2]), 0); continue; }
      }
      var src = media.getAttribute('data-accent-src');
      if (src) fromImage(media, src);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
